module.exports = __webpack_public_path__ + "static/img/logo1.a797a874.png";